import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "redux/store";
import { Table } from "@zendeskgarden/react-tables";
import { ReactComponent as OverflowVerticalStorke } from "@zendeskgarden/svg-icons/src/16/overflow-vertical-stroke.svg";
import { Button, IconButton } from "@zendeskgarden/react-buttons";
import { Toggle, Field } from "@zendeskgarden/react-forms";
import { Tag } from "@zendeskgarden/react-tags";
import useTable from "hooks/useTable";
import useAsyncFn from "hooks/useAsyncFn";
import BackendApi from "api/backendApi";
import { dispatch } from "redux/store";
import { setFilterEnum, setStore } from "redux/slices/initOptions";
import { homeFilterList } from "utils/constant";
import { toastTips, toggleScroll } from "utils/tools";
import { handleAsyncTemplateData } from "utils/data";
import { Menu, Item } from "@zendeskgarden/react-dropdowns";
import RenderInlineNotification from "components/RenderInlineNotification";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import EditTemplate from "pages/EditTemplate/EditTemplate";
import ViewTemplate from "pages/EditTemplate/ViewTemplate";
import { StatusIndicator } from "@zendeskgarden/react-avatars";
import { checkRole } from "utils/tools";

//
const initialState = {
  isLoading: false,
  isError: false,
  active: true,
  data: [],
};

const initParams = {
  name: "",
  intent: [],
  auto_reply: "",
  sort_asc: "",
  sort_desc: "",
  page: 1,
  page_size: 20,
};

export default function Template() {
  const role = useSelector((state) => state.user.role);
  let filterParamsInitParams = { ...initParams };
  //用于后端参数传递
  const { filterParams, setFilterParams } = useTable({ defaultFilterParams: filterParamsInitParams });
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editButtonView, setEditButtonView] = useState(false);
  const [intentList, setIntentList] = useState([]);

  //用于页面上filter的初始参数
  const [homeFilter, setHomeFilter] = useState([]);

  const [editTemplateItem, setEditTemplateItem] = useState("");
  const [templateState, fetchTempData] = useAsyncFn(
    () => BackendApi.getTemplateList(filterParams),
    [filterParams],
    initialState,
  );

  const getIntentList = () => {
    BackendApi.getIntentList().then((res) => {
      if (!res || res.status != "Success" || !res.data || !res.data.intent || res.data.intent.length == 0) {
        console.log("Get intent list error");
        throw new Error("Get intent list error");
      }
      setIntentList(res.data.intent);
    });
  };

  const formatTemplateData = (templateRawData, intentList) => {
    let templateDataRows = [];

    templateRawData.forEach((x) => {
      let templateObj = {
        intent: intentList.find((y) => y.value == x.intent)?.label,
        tag: x.custom_tag,

        tag_to_zd: x.enable_add_custom_tag == 1 ? "Yes" : "No",

        auto_reply: x.enable_auto_reply == 1 ? "Yes" : "No",
        confidence_score: x.confidence_score,
        template_status: x.is_active == 1 ? "Active" : "Inactive",
        message: x.template_content,
      };

      templateDataRows.push(templateObj);
    });

    // console.log({templateDataRows});
    // 返回templateDataRows数组
    return templateDataRows;
  };

  const handleExportToExcel = () => {
    let exportTemplateParams = {
      ...initParams,
      sort_asc: "intent",
    };
    exportTemplateParams.is_export_templates = 1;
    BackendApi.getTemplateList(exportTemplateParams)
      .then((res) => {
        if (!res || res.status != "Success" || !res.data || !res.data.list || res.data.list.length == 0) {
          console.log("Export templates data error");
          throw new Error("Export templates data error");
        }

        let templateRawData = res.data.list;
        let templateData = formatTemplateData(templateRawData, intentList);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(templateData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        /* fix headers */
        const sheet1Headers = [
          "Intent(Tag)",
          "Additional Tag",
          "Tag to Zendesk",
          "Auto Reply",
          "Confidence Score",
          "Template Status",
          "Template",
        ];
        XLSX.utils.sheet_add_aoa(worksheet, [sheet1Headers], { origin: "A1" });

        XLSX.writeFile(workbook, "template_list.xlsx");
        toastTips("Export templates success", "success", "tips");
      })
      .catch((error) => {
        toastTips("Export templates error", "error");
      });
  };

  //will scroll the view or not
  const toggleEditModal = () => {
    toggleScroll(!editModal);
    setEditModal(!editModal);
  };

  const search = (e) => {
    setFilterParams({ ...filterParams, name: e.target.value });
  };
  /**
   *设置筛选条件
   *
   * @param {*} obj
   */
  const filterCallback = (obj) => {
    setFilterParams({ ...filterParams, page: 1, page_size: 20, ...obj });
  };

  /**
   *重置筛选条件
   *
   */
  const resetFilter = () => {
    setFilterParams(initParams);
  };

  useEffect(() => {
    fetchTempData();
  }, [filterParams]); //deps

  useEffect(() => {
    BackendApi.getTemplatFilterEnum()
      .then((res) => {
        // const homeFilterListTmp = deepClone(homeFilterList);
        const enumData = res.data;
        homeFilterList.forEach((item) => {
          if (enumData[item.mapKey]) {
            item.options = enumData[item.mapKey]?.map((item2) => {
              if (typeof item2 === "object") {
                return { value: item2.value, text: item2.label };
              } else {
                return item2;
              }
            });
          }
        });
        dispatch(setFilterEnum(enumData));
      })
      .catch((e) => console.log(e));
  }, []);

  const toastTR = (message = "", type = "success") => {
    toast(<RenderInlineNotification message={message} type={type} />, {
      containerId: "main",
    });
  };

  const toggleViewModal = () => {
    setViewModal(!viewModal);
  };

  const andleTableRowAttrClick = (e, index, attrKey) => {
    const value = e.target.checked ? 1 : 0;
    const editData = handleAsyncTemplateData(templateState.data.list, intentList)["backend"][index];

    if (editData.message === "" || editData.message === null) {
      toastTR("Please fill in the template content first", "error");
      return;
    }

    if (attrKey === "auto_reply" && editData.template_status === 0) {
      toastTR("Please activate the template first", "error");
      return;
    }
    if (attrKey === "template_status" && value == 1 && editData.message.length === 0) {
      toastTR("Please fill in the template content first", "error");
      return;
    }
    let editDataTmp;
    if (attrKey === "template_status" && value == 0) {
      editDataTmp = { ...editData, [attrKey]: value, auto_reply: 0 };
    } else {
      editDataTmp = { ...editData, [attrKey]: value };
    }

    BackendApi.saveTemplate(editDataTmp).then((res) => {
      fetchTempData();
    });
  };
  const resetTemplate = (e, index) => {
    const editData = handleAsyncTemplateData(templateState.data.list)["backend"][index];

    const editDataTmp = {
      ...editData,
      tag: "",
      auto_reply: 0,
      template_status: 0,
      tag_to_zd: 0,
      confidence_score: 0.75,
      message: "",
    };
    BackendApi.saveTemplate(editDataTmp).then(() => {
      toastTR("Reset template success", "success");
      fetchTempData();
    });
    e.stopPropagation();
  };
  const editTempalte = useCallback(
    (e, index) => {
      toggleEditModal();

      setEditTemplateItem(handleAsyncTemplateData(templateState.data.list, intentList)["backend"][index]);
      e.stopPropagation();
    },
    [templateState.data.list, intentList],
  );

  useEffect(() => {
    console.log("Template useEffect");
    checkRole(role) ? setEditButtonView(true) : setEditButtonView(false);
    getIntentList();
  }, []);
  return (
    <>
      <div className="home_wrapper">
        <Table>
          <Table.Caption>
            <div className="flex justify-between w-full">
              <span className="text-[16px] leading-6  pl-2">Auto Reply Templates</span>
              <Button onClick={handleExportToExcel}>Export</Button>
            </div>
          </Table.Caption>
          <Table.Head>
            <Table.HeaderRow>
              <Table.HeaderCell>Intent(Tag)</Table.HeaderCell>
              <Table.HeaderCell>Additional Tag</Table.HeaderCell>
              <Table.HeaderCell>Auto Reply</Table.HeaderCell>
              <Table.HeaderCell>Activate Template</Table.HeaderCell>
              <Table.HeaderCell>Confidence Score</Table.HeaderCell>
              {editButtonView && (
                <Table.HeaderCell>
                  <div style={{ padding: "12px 12px 0px 12px" }}>
                    <OverflowVerticalStorke />
                  </div>
                </Table.HeaderCell>
              )}
            </Table.HeaderRow>
          </Table.Head>
          <Table.Body>
            {handleAsyncTemplateData(templateState.data.list, intentList)["frontend"].map((row, index) => (
              <Table.Row
                key={index}
                onClick={() => {
                  toggleViewModal();
                  setEditTemplateItem(handleAsyncTemplateData(templateState.data.list, intentList)["backend"][index]);
                }}
              >
                <Table.Cell>{row.intent_label}</Table.Cell>
                <Table.Cell>{row.tag}</Table.Cell>
                {/* <Table.Cell>{row.auto_reply}</Table.Cell>
                <Table.Cell>{row.template_status}</Table.Cell> */}
                <Table.Cell>
                  {editButtonView ? (
                    <Field
                      onChange={(e) => {
                        andleTableRowAttrClick(e, index, "auto_reply");
                      }}
                    >
                      <Toggle checked={row.auto_reply === 1}>
                        <Field.Label hidden>{row.auto_reply}</Field.Label>
                      </Toggle>
                    </Field>
                  ) : (
                    <StatusIndicator type={row.auto_reply === 1 ? "available" : "offline"} isCompact>
                      {row.auto_reply === 1 ? "On" : "Off"}
                    </StatusIndicator>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {editButtonView ? (
                    <Field
                      onChange={(e) => {
                        andleTableRowAttrClick(e, index, "template_status");
                      }}
                    >
                      <Toggle checked={row.template_status === 1}>
                        <Field.Label hidden>{row.template_status}</Field.Label>
                      </Toggle>
                    </Field>
                  ) : (
                    <StatusIndicator type={row.template_status === 1 ? "available" : "offline"} isCompact>
                      {row.template_status === 1 ? "On" : "Off"}
                    </StatusIndicator>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <Tag hue="#1371D6" isPill style={{ height: "32px" }}>
                    <div className="p-2">
                      <span>{row.confidence_score}</span>
                    </div>
                  </Tag>
                </Table.Cell>
                {editButtonView && (
                  <Table.Cell>
                    <Menu
                      hasArrow
                      button={(props) => (
                        <IconButton {...props}>
                          <OverflowVerticalStorke />
                        </IconButton>
                      )}
                      onChange={() => {}}
                    >
                      <Item
                        value="hydrangea"
                        onClick={(e) => {
                          editTempalte(e, index);
                        }}
                      >
                        Edit template
                      </Item>
                      <Item value="petunia" onClick={(e) => resetTemplate(e, index)}>
                        Reset template
                      </Item>
                    </Menu>
                  </Table.Cell>
                )}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {editModal && (
        <EditTemplate
          toggleEditModal={toggleEditModal}
          setFilterParams={setFilterParams}
          editTemplateItem={editTemplateItem}
        />
      )}
      {viewModal && <ViewTemplate editTemplateItem={editTemplateItem} toggleViewModal={toggleViewModal} />}
    </>
  );
}
